import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { InsumoValidateContent } from './components/InsumoValidateContent';

export default function InsumoValidar() {

    return (
        <MainContent component={<InsumoValidateContent/>} titulo='Validar Insumos' tableMaxWidth />
    );

};